import {
  Card,
  Grid,
  makeStyles,
  Menu,
  MenuItem,
  Paper,
  Typography,
  withStyles,
} from '@material-ui/core';
import ArrowBackIosRounded from '@material-ui/icons/ArrowBackIosRounded';
import React, { useRef, useState } from 'react';

import {
  dashboardTitleBlockedAds,
  dashboardTitleBlockedRate,
  dashboardTitleInvalidTrafficAds,
  dashboardTitleInvalidTrafficRate,
} from '~/src/dash/api/ias-wrapper-api/constants';
import { CardWithHoverColorChange } from '~/src/dash/components/model-card';
import {
  HomeDashboardCardDataTitles,
  IHomeDashboardCardDataDisplay,
} from '~/src/dash/globals/constants';
import { DashboardCardDataTitles, ISelectedMetric } from '~/src/dash/globals/constants';
import {
  FirstAndThirdPartyDashboardCardDataTitles,
  IFirstAndThirdPartyDashboardCardDataDisplay,
} from '~/src/dash/views/measurement-home-view';
import {
  IStreamAggregateCardDataDisplay,
  IStreamErrorCardDataDisplay,
  IStreamKPICardDataDisplay,
  IStreamLatencyCardDataDisplay,
  networkHomeAggDataTitles,
  StreamDashboardCardDataTitles,
} from '~/src/dash/views/networks/constants';

const { AGG_STREAM_STREAM_ERROR_TITLE, AGG_STREAM_AVG_STREAM_AD_FILL_LATENCY_TITLE } =
  networkHomeAggDataTitles;

interface IProps {
  loading: boolean;
  loaded: boolean;
  entries:
    | IStreamAggregateCardDataDisplay
    | IStreamKPICardDataDisplay
    | IStreamLatencyCardDataDisplay
    | IStreamErrorCardDataDisplay
    | IFirstAndThirdPartyDashboardCardDataDisplay
    | IHomeDashboardCardDataDisplay;
  entriesCompare:
    | IStreamAggregateCardDataDisplay
    | IStreamKPICardDataDisplay
    | IStreamLatencyCardDataDisplay
    | IStreamErrorCardDataDisplay
    | IFirstAndThirdPartyDashboardCardDataDisplay
    | IHomeDashboardCardDataDisplay;
  compareEnabled: boolean;
  menuItemList: string[];
  handleSwitchActiveMetric: (idx: number) => void;
  handleSwitchCardSelected: (inactiveKey: DashboardCardDataTitles, index: number) => void;
  selectedMetricsColorMap: Record<string, string>;
  selectedMetrics: ISelectedMetric[];
}

const useStyles = makeStyles({
  paperCards: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    boxShadow: '0px 3px 4px #E2E2E2',
    minHeight: 85,
    borderRadius: 2,
  },
  dashboardCard: {
    backgroundColor: 'white',
    padding: 10,
  },
  dashboardCardTitleWhite: {
    margin: '3px 0px 0px 8px',
    fontWeight: 500,
    fontSize: 14,
    color: '#FFFFFF',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    cursor: 'pointer',
    wordWrap: 'break-word',
  },
  dashboardCardTitleDark: {
    margin: '3px 0px 0px 8px',
    fontWeight: 500,
    fontSize: 14,
    color: '#292F36',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    cursor: 'pointer',
    wordWrap: 'break-word',
  },
  dashboardCardTitleWhiteNoHover: {
    margin: '0px 0px 0px 8px',
    fontWeight: 500,
    fontSize: 14,
    color: '#FFFFFF',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    cursor: 'pointer',
  },
  dashboardCardTitleDarkNoHover: {
    margin: '0px 0px 0px 8px',
    fontWeight: 500,
    fontSize: 14,
    color: '#292F36',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    cursor: 'pointer',
  },
  dashboardCardValueDark: {
    paddingLeft: 12,
    paddingRight: 2,
    textAlign: 'left',
    fontSize: 24,
    color: '#292F36',
    fontWeight: 600,
  },
  dashboardCardSuffixDark: {
    fontSize: 24,
    paddingBottom: 5,
    color: '#292F36',
    fontWeight: 700,
  },
  dashboardCardValueWhite: {
    paddingLeft: 12,
    paddingRight: 2,
    textAlign: 'left',
    fontSize: 24,
    color: '#FFFFFF',
    fontWeight: 600,
  },
  dashboardCardSuffixWhite: {
    fontSize: 24,
    paddingBottom: 5,
    color: '#FFFFFF',
    fontWeight: 700,
  },
  dashboardCardValueSmallWhite: {
    padding: '4px 12px',
    fontWeight: 400,
    textAlign: 'left',
    fontSize: 12,
    color: '#FFFFFF',
  },
  dashboardCardValueSmallDark: {
    padding: '4px 12px',
    fontWeight: 400,
    textAlign: 'left',
    fontSize: 12,
    color: '#292F36',
  },
  dashboardCardComparePositive: {
    padding: '4px 6px',
    fontWeight: 500,
    textAlign: 'left',
    fontSize: 12,
    color: '#00B7A9',
  },
  dashboardCardCompareNegative: {
    padding: '4px 6px',
    fontWeight: 500,
    textAlign: 'left',
    fontSize: 12,
    color: '#F03827',
  },
  menuRoot: {
    backgroundColor: '#FFFFFF',
    // width: '100%',
    boxShadow: '0px 3px 4px #e2e2e2',
  },
  dashboardCardText: {
    fontSize: 11,
    color: '#292F36',
  },
  dashboardTitleCard: {
    boxShadow: 'none',
    marginLeft: '4px',
    marginTop: '3px',
  },
  dashboardTitleText: {
    marginLeft: '8px',
    marginTop: '3px',
  },
  arrowDown: {
    transform: 'rotate(180deg)',
  },
});

const DropdownMenuItem = withStyles({
  root: {
    width: '180px',
    height: '32px',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#F0F3F4',
      color: '#292F36',
    },
    fontSize: 14,
    padding: '12px 12px',
  },
})(MenuItem);

export const DashboardCards = (props: IProps) => {
  // props
  const {
    entries,
    entriesCompare,
    compareEnabled,
    loading,
    loaded,
    menuItemList,
    selectedMetricsColorMap,
    handleSwitchCardSelected,
    handleSwitchActiveMetric,
    selectedMetrics,
  } = props;
  const classes = useStyles();

  // state
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const dropdownRef0 = useRef<HTMLDivElement>(null);
  const dropdownRef1 = useRef<HTMLDivElement>(null);
  const dropdownRef2 = useRef<HTMLDivElement>(null);
  const dropdownRef3 = useRef<HTMLDivElement>(null);
  const dropdownRef4 = useRef<HTMLDivElement>(null);
  const dropdownRef5 = useRef<HTMLDivElement>(null);
  const dropdownRefMap = {
    0: dropdownRef0,
    1: dropdownRef1,
    2: dropdownRef2,
    3: dropdownRef3,
    4: dropdownRef4,
    5: dropdownRef5,
  } as { [key: number]: React.RefObject<HTMLDivElement> };
  const menuRef0 = useRef<HTMLDivElement>(null);
  const menuRef1 = useRef<HTMLDivElement>(null);
  const menuRef2 = useRef<HTMLDivElement>(null);
  const menuRef3 = useRef<HTMLDivElement>(null);
  const menuRef4 = useRef<HTMLDivElement>(null);
  const menuRef5 = useRef<HTMLDivElement>(null);
  const menuRefMap = {
    0: menuRef0,
    1: menuRef1,
    2: menuRef2,
    3: menuRef3,
    4: menuRef4,
    5: menuRef5,
  } as { [key: number]: React.RefObject<HTMLDivElement> };
  const [dropdownActiveKey, setDropdownActiveKey] = useState('' as DashboardCardDataTitles | '');
  const [dropdownActiveIndex, setDropdownActiveIndex] = useState(-1);

  const hasInvertedCompareSymbol = (key: DashboardCardDataTitles): boolean => {
    const invertedMetricKeys = [
      // network dash
      AGG_STREAM_AVG_STREAM_AD_FILL_LATENCY_TITLE,
      AGG_STREAM_STREAM_ERROR_TITLE,
      // measurement dash
      dashboardTitleBlockedAds,
      dashboardTitleBlockedRate,
      dashboardTitleInvalidTrafficAds,
      dashboardTitleInvalidTrafficRate,
    ];
    return invertedMetricKeys.includes(key);
  };

  // helper handler functions
  const handleClick = (
    event: React.MouseEvent<HTMLElement>,
    activeKey: DashboardCardDataTitles,
    activeIndex: number,
  ) => {
    setAnchorEl(event.currentTarget);
    setDropdownActiveKey(activeKey);
    setDropdownActiveIndex(activeIndex);
  };

  const handleClose = () => {
    setDropdownActiveKey('');
    setDropdownActiveIndex(-1);
    setAnchorEl(null);
  };

  const getCompareTextClass = (activeKey: DashboardCardDataTitles, compareSign: number): string => {
    if (hasInvertedCompareSymbol(activeKey)) {
      if (compareSign === -1) {
        return classes.dashboardCardComparePositive;
      } else {
        return classes.dashboardCardCompareNegative;
      }
    } else {
      if (compareSign === -1) {
        return classes.dashboardCardCompareNegative;
      } else {
        return classes.dashboardCardComparePositive;
      }
    }
  };

  const renderCardTitle = (
    active: boolean,
    activeKey: DashboardCardDataTitles,
    activeIndex: number,
    headerColor: string,
  ) => {
    if (active) {
      return (
        <CardWithHoverColorChange
          ref={dropdownRefMap[activeIndex]}
          alignItems='flex-start'
          onClick={(e: React.MouseEvent<HTMLElement>) => handleClick(e, activeKey, activeIndex)}
          className={classes.dashboardTitleCard}
        >
          <Grid container>
            <Typography
              className={
                headerColor === '#FFFFFF'
                  ? classes.dashboardCardTitleDark
                  : classes.dashboardCardTitleWhite
              }
            >
              {activeKey}
            </Typography>
            <Typography
              className={
                headerColor === '#FFFFFF'
                  ? classes.dashboardCardTitleDarkNoHover
                  : classes.dashboardCardTitleWhiteNoHover
              }
            >
              <ArrowBackIosRounded
                style={{
                  transform:
                    activeIndex === dropdownActiveIndex ? 'rotate(90deg)' : 'rotate(270deg)',
                  fontSize: 16,
                  marginTop: 5,
                  marginRight: '4px',
                }}
              />
            </Typography>
          </Grid>
        </CardWithHoverColorChange>
      );
    }
    return (
      <Card
        ref={dropdownRefMap[activeIndex]}
        className={classes.dashboardTitleCard}
        onClick={() => handleSwitchActiveMetric(activeIndex)}
      >
        <Grid container>
          <Typography
            className={
              headerColor === '#FFFFFF'
                ? classes.dashboardCardTitleDark
                : classes.dashboardCardTitleWhite
            }
          >
            {activeKey}
          </Typography>
        </Grid>
      </Card>
    );
  };

  const renderMenuDropdown = (activeKey: DashboardCardDataTitles, activeIndex: number) => {
    return (
      <Menu
        key={`menu-${activeKey}-${activeIndex}`}
        elevation={0}
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        ref={menuRefMap[activeIndex]}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        keepMounted
        open={dropdownActiveIndex === activeIndex && !loading}
        onClose={handleClose}
        classes={{
          paper: classes.menuRoot,
        }}
      >
        {menuItemList.map((key: DashboardCardDataTitles, idx: number) => {
          return (
            <DropdownMenuItem
              key={`menuitem-${activeKey}-${key}-${idx}!`}
              onClick={() => {
                if (dropdownActiveKey !== '') {
                  handleSwitchCardSelected(key, dropdownActiveIndex);
                  handleClose();
                }
              }}
            >
              {key}
            </DropdownMenuItem>
          );
        })}
      </Menu>
    );
  };

  const renderCardValue = (
    activeKey:
      | StreamDashboardCardDataTitles
      | FirstAndThirdPartyDashboardCardDataTitles
      | HomeDashboardCardDataTitles,
    activeIndex: number,
    headerColor: string,
  ) => {
    // TO-DO: LiveDashV2: Fix this component to no longer require ts-ignore to be typescript-compatible...
    // @ts-ignore
    const value = entries[activeKey];

    return (
      <Grid style={{ height: '100%', width: '100%', backgroundColor: headerColor }}>
        <Grid container direction='row' alignItems='flex-end'>
          <Grid item>
            <Typography
              className={
                selectedMetrics[activeIndex].active
                  ? classes.dashboardCardValueWhite
                  : classes.dashboardCardValueDark
              }
            >
              {(value || { value: 'No data available' }).value}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className={
                selectedMetrics[activeIndex].active
                  ? classes.dashboardCardSuffixWhite
                  : classes.dashboardCardSuffixDark
              }
            >
              {(value || { suffix: '' }).suffix}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderCardCompare = (
    activeKey: DashboardCardDataTitles,
    activeIndex: number,
    headerColor: string,
    currCompareTextClass: string,
    compareSign: number,
    compareValue: string,
  ) => {
    return (
      <Grid
        item
        style={{
          height: '100%',
          width: '100%',
          paddingLeft: 12,
          backgroundColor: '#FFFFFF',
          borderTop:
            compareEnabled && !selectedMetrics[activeIndex].active
              ? '0.5px solid lightgrey'
              : '0.5px solid ' + headerColor,
          borderRadius: 2,
        }}
      >
        <Grid container direction='row' alignItems='center'>
          <Grid item style={{ padding: '0px 0px 2px 0px' }}>
            {compareSign === -1 && !hasInvertedCompareSymbol(activeKey) && (
              <img src='/assets/shared/svg/RedArrow.svg' className={classes.arrowDown} />
            )}
            {compareSign === -1 && hasInvertedCompareSymbol(activeKey) && (
              <img src='/assets/shared/svg/Arrow.svg' className={classes.arrowDown} />
            )}
            {compareSign === 1 && hasInvertedCompareSymbol(activeKey) && (
              <img src='/assets/shared/svg/RedArrow.svg' />
            )}
            {compareSign === 1 && !hasInvertedCompareSymbol(activeKey) && (
              <img src='/assets/shared/svg/Arrow.svg' />
            )}
          </Grid>
          <Grid item style={{ minWidth: 57 }}>
            <Typography className={currCompareTextClass}>{compareValue}</Typography>
          </Grid>
          <Grid item>
            <Typography className={classes.dashboardCardText}>/ previous period</Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderLoading = (active: boolean) => {
    if (active) {
      return <Typography className={classes.dashboardCardValueSmallWhite}>Loading...</Typography>;
    }
    return <Typography className={classes.dashboardCardValueSmallDark}>Loading...</Typography>;
  };

  const renderCard = (metric: ISelectedMetric, activeIndex: number) => {
    const activeKey = metric.key;
    let compareValue, compareSign;
    let headerColor = selectedMetricsColorMap[activeIndex];
    if (activeKey in entriesCompare) {
      // @ts-ignore
      const compareEntry = entriesCompare[activeKey] || { value: 0, sign: 1, color: '#00324a' };
      compareValue = compareEntry.value;
      compareSign = compareEntry.sign;
    }
    const currCompareTextClass = getCompareTextClass(activeKey, compareSign || 0);
    if (activeKey in entries && !selectedMetrics[activeIndex].active) {
      headerColor = '#FFFFFF';
    }
    return (
      <Grid item key={`${activeKey}-${activeIndex}-${compareValue}`} lg={2} md={4} sm={6} xs={12}>
        <Paper
          className={classes.paperCards}
          onClick={(e) => {
            const notOpeningDropdown = !dropdownRefMap[activeIndex].current!.contains(
              e.target as Node,
            );
            const notClickingDropdownMenuItem = !menuRefMap[activeIndex].current!.contains(
              e.target as Node,
            );
            if (notOpeningDropdown && notClickingDropdownMenuItem) {
              handleSwitchActiveMetric(activeIndex);
            }
          }}
          style={{ backgroundColor: headerColor }}
        >
          <Grid item style={{ backgroundColor: headerColor, height: 45, borderRadius: '2px' }}>
            <Grid container>
              {!loading && renderCardTitle(metric.active, activeKey, activeIndex, headerColor)}
            </Grid>
          </Grid>
          {!loading && renderMenuDropdown(activeKey, activeIndex)}
          {!loading ? (
            loaded ? (
              <>
                <Grid
                  container
                  direction='column'
                  alignItems='flex-start'
                  style={{ marginTop: '-12px' }}
                >
                  {renderCardValue(activeKey, activeIndex, headerColor)}
                  {compareEnabled &&
                    renderCardCompare(
                      activeKey,
                      activeIndex,
                      headerColor,
                      currCompareTextClass,
                      compareSign || 1,
                      compareValue || '',
                    )}
                </Grid>
              </>
            ) : (
              renderLoading(selectedMetrics[activeIndex].active)
            )
          ) : (
            renderLoading(selectedMetrics[activeIndex].active)
          )}
        </Paper>
      </Grid>
    );
  };

  return (
    <section>
      <Grid container alignItems='center' spacing={2} style={{ cursor: 'pointer' }}>
        {selectedMetrics.map((metric: ISelectedMetric, activeIndex: number) =>
          renderCard(metric, activeIndex),
        )}
      </Grid>
    </section>
  );
};
